import React, { useState } from 'react';
import { Grid, Button, FormControl, Typography, ListItem, ListItemText, IconButton, ListItemIcon } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';

const DocumentUploader = ({ onUpload, documentList, existDocumentList, onRemove, onRemoveExistDoc }) => {
    const handleDocumentUpload = (e) => {
        onUpload(Array.from(e.target.files));
    };


    const handleOpenBlob = (blobUrl) => {
        window.open(blobUrl, '_blank');
    };
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={4}>
                <FormControl fullWidth>
                    <input
                        type="file"
                        onChange={handleDocumentUpload}
                        style={{ display: 'none' }}
                        id="file-upload"
                        multiple
                    />
                    <label htmlFor="file-upload">
                        <Button variant="contained" component="span">
                            Upload Document
                        </Button>
                    </label>
                </FormControl>
            </Grid>

            {documentList.length > 0 && (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h6" sx={{ paddingLeft: 2, marginTop: 2 }}>Uploaded Documents:</Typography>
                        {documentList.map((file, index) => (

                            <ListItem
                                key={index}
                                secondaryAction={
                                    <>
                                        <IconButton edge="end" onClick={() => onRemove(index)}>
                                            <DeleteIcon />
                                        </IconButton>

                                    </>
                                }
                            >
                                <ListItemText primary={file.name} secondary={`Size: ${file.size} bytes`} />
                            </ListItem>
                        ))}
                    </Grid>
                </Grid>
            )}

            {existDocumentList.length > 0 && (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h6" sx={{ paddingLeft: 2, marginTop: 2 }}>Existing Documents:</Typography>
                        {existDocumentList.map((file, index) => (

                            <ListItem
                                key={index}
                                secondaryAction={
                                    <>
                                        <IconButton edge="end" onClick={() => handleOpenBlob(file.blobUrl)}>
                                            <DownloadIcon />
                                        </IconButton>
                                        <IconButton edge="end" onClick={() => onRemoveExistDoc(index)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </>
                                }
                            >
                                <ListItemText primary={file.fileName} />
                            </ListItem>
                        ))}
                    </Grid>
                </Grid>
            )}
        </Grid>
    );
};

export default DocumentUploader;
